<template>
  <div style="width: 100%;height: 0px;">
    <div style="width: 100%; height: 36px;  line-height: 36px; background: rgb(1 66 152);">
      <div style="width: 100%;max-width: 1200px;margin: 0 auto;color: #FFFFFF;font-size: 14px;">
        <div style="float: left">
          欢迎光临供应链企业信用管理平台
        </div>
        <div style="float: right"  >
          <span style="cursor: pointer;margin-right: 20px;font-weight: bold;" v-if="!show()" @click="zc" >注册</span>
          <i></i>
          <span  style="cursor: pointer;margin-right: 20px;font-weight: bold;" v-if="!show()" @click="login">登录</span>
          <i></i>
          <span  style="cursor: pointer;margin-right: 20px;font-weight: bold;margin-right: 10px" v-if="show()" @click="cz">充值中心</span>
          <i></i>
          <span  style="cursor: pointer;margin-right: 20px;font-weight: bold;margin-right: 10px" v-if="show()" @click="user">报告记录</span>
          <i></i>
          <span  style="cursor: pointer;margin-right: 20px;font-weight: bold;" v-if="show()" @click="loginout">退出</span>

        </div>
      </div>
    </div>

<!--    <div style="width: 1200px;height: auto;margin: 0 auto;">-->
<!--       <div style="float: left;margin-top: 20px;margin-left: 20px;"></div>-->
<!--      <div style="float: right" class="ul-list">-->
<!--        <ul >-->
<!--          <li>-->
<!--            <router-link to="/" @click.native="navMenuClick()" class="active">首页</router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <router-link to="/report" @click.native="navMenuClick()">供应链信用</router-link>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a href="https://lvyuexinyong.com/" target="_blank">合同履约</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a href="https://wuyexinyong.com/" target="_blank">物业信用</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <router-link to="/me" @click.native="navMenuClick()">关于平台</router-link>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->


  </div>
</template>

<script>
import {mapActions} from "vuex"
import router from "@/router";

export default {
  name: "HomeHeader",
  props: {},
  data() {
    return {
      isMinScreen: this.$root.$data.isMinScreen,
      headerTitle:"",
    }
  },
  created() {
    router.beforeEach((to, from ,next) => {
      if (to.meta.title === "首页") {
        this.headerTitle="";
      }else{
        this.headerTitle=to.meta.title;
      }
      next();
    })

  },
  watch: {
    //监听是否是小窗口界面
    "$root.$data.isMinScreen": function (val) {
      if (typeof val === 'boolean') {
        this.isMinScreen = val
      }
      //非小屏幕
      if (!val) {
        document.getElementsByClassName('nav-menu-box').item(0).style.display = 'block'
        let listSubList = document.querySelectorAll('.start-list-sub')
        listSubList.forEach(function (v) {
          v.removeAttribute('style')
        })
      }
    },
  },
  methods: {
    //小窗口菜单显示逻辑
    showMobileNav() {
      let navDom = document.getElementsByClassName('nav-menu-box').item(0)
      navDom.style.display = (!navDom.style.display || navDom.style.display === 'none') ? "block" : "none"
    },
    subNavOpen(e) {
      let listSubList = document.querySelectorAll('.start-list-sub')
      listSubList.forEach(function (v) {
        if (v === e.currentTarget.previousElementSibling) {
          v.style.display = (v.style.display === 'block') ? "none" : "block"
        } else {
          v.style.display = 'none'
        }
      })
      //document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
    },
    //菜单点击原生事件
    navMenuClick() {
      if (this.isMinScreen) {
        document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
      }
    },
    //搜索页面
    showSearchPage() {
      this.$router.push('/m-search')
    },
    zc() {
      this.$router.push('/register')
    },
    login() {
      this.$router.push('/login')
    },
    cz(){
      this.$router.push('/pay')
    },
    user(){
      this.$router.push('/user')
    },
    ...mapActions(["Logout"]),
    loginout() {
      const that = this
      that.Logout({}).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.$router.push('/')
        } else {
          this.$message.error(res.message)
        }
      });
    },
    show(){
      if(this.$store.state.token){
        return true;
      }
      return false;
    }
  }

}
</script>

<style scoped>
/*.ul-list ul{*/
/*  display: block;*/
/*  list-style-type: disc;*/
/*  margin-block-start: 1em;*/
/*  margin-block-end: 1em;*/
/*  margin-inline-start: 0px;*/
/*  margin-inline-end: 0px;*/
/*  padding-inline-start: 40px;*/
/*}*/
/*.ul-list ul li{*/
/*  float: left;*/
/*  position: relative;*/
/*  list-style: none;*/
/*}*/

/*.ul-list>ul>li>a{*/
/*  margin: 20px 10px;*/
/*  position: relative;*/
/*  display: block;*/
/*  color: #333333;*/
/*  font-size: 18px;*/
/*  font-weight: 600;*/
/*  line-height: 40px;*/
/*  padding: 0 15px;*/
/*}*/

/*.ul-list>ul>li>a {*/
/*  color: #ffffff;*/
/*}*/

/*.ul-list ul li .active::after {*/
/*  color: #FF9900;*/
/*  content: "";*/
/*  position: absolute;*/
/*  height: 2px;*/
/*  width: 80%;*/
/*  background: #FF9900;*/
/*  bottom: 0;*/
/*  left: 50%;*/
/*  opacity: 1;*/
/*}*/

/*.ul-list ul li .active {*/
/*  color: #FF9900;*/
/*}*/


/*.ul-list>ul>li>a:after {*/
/*  content: '';*/
/*  position: absolute;*/
/*  width: 0;*/
/*  height: 2px;*/
/*  background: #FF9900;*/
/*  bottom: 0;*/
/*  transform: translateX(-50%);*/
/*  transition: all 0.6s cubic-bezier(.075, .82, .165, 1);*/
/*  left: 50%;*/
/*  opacity: 1;*/
/*  display:inline-block;*/
/*}*/

.ul-list {
  float: right;
}
.ul-list ul li {
  float: left;
  position: relative;
}

.ul-list ul li .subnav{
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  width:130px;
  height: auto;
  z-index: 10;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 13px 42px 11px rgba(0, 0, 0, 0.05);
  opacity: 0;
  visibility: hidden;
  transition: all 0.36s ease;

}
.ul-list .subnav li{
  float: none;
}
.ul-list .subnav li a{
  width: 100%;
  font-size: 13px;
  display: block;
  font-weight: 500;
  line-height: 48px;
  color: #ffffff;
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
  text-align: center;

}

.ul-list .subnav li:hover{
  background: #FF9900;
}
.ul-list .subnav li:hover a{
  color: #fff;
}
.ul-list>ul>li>a{
  margin: 20px 10px;
  position: relative;
  display: inline-block;
  color: #ffffff;
  line-height: 40px;
  padding:0 15px;
  font-size: 18px;
  font-weight: 600;
  line-height: 40px;
}

.ul-list ul li .active {
  color: #FF9900;
}

.ul-list ul li .active:after {
  color: #FF9900;
  content: "";
  position: absolute;
  height: 2px;
  width: 80%;
  background: #FF9900;
  bottom: 0;
  left: 50%;
  opacity: 1
}

.ul-list>ul>li>a:after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  background: #FF9900;
  bottom: 0;
  transform: translateX(-50%);
  transition: all 0.6s cubic-bezier(.075, .82, .165, 1);
  left: 50%;
  opacity: 1
}

.ul-list>ul>li:hover>a:after {
  width: 80%;
  opacity: 1;
}


</style>
